/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Profile_Editors_Birth_DayInputs */

const en_us2_profile_editors_birth_day = /** @type {(inputs: Profile_Editors_Birth_DayInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Day`)
};

const pt_br2_profile_editors_birth_day = /** @type {(inputs: Profile_Editors_Birth_DayInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Dia`)
};

const es_419_profile_editors_birth_day = /** @type {(inputs: Profile_Editors_Birth_DayInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Día`)
};

const pt_pt2_profile_editors_birth_day = /** @type {(inputs: Profile_Editors_Birth_DayInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Dia`)
};

const fr_fr2_profile_editors_birth_day = /** @type {(inputs: Profile_Editors_Birth_DayInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Jour`)
};

const de_de2_profile_editors_birth_day = /** @type {(inputs: Profile_Editors_Birth_DayInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tag`)
};

const it_it2_profile_editors_birth_day = /** @type {(inputs: Profile_Editors_Birth_DayInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Giorno`)
};

/**
* | output |
* | --- |
* | "Day" |
*
* @param {Profile_Editors_Birth_DayInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const profile_editors_birth_day = /** @type {((inputs?: Profile_Editors_Birth_DayInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Profile_Editors_Birth_DayInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_profile_editors_birth_day(inputs)
	if (locale === "es-419") return es_419_profile_editors_birth_day(inputs)
	if (locale === "pt-PT") return pt_pt2_profile_editors_birth_day(inputs)
	if (locale === "fr-FR") return fr_fr2_profile_editors_birth_day(inputs)
	if (locale === "de-DE") return de_de2_profile_editors_birth_day(inputs)
	if (locale === "it-IT") return it_it2_profile_editors_birth_day(inputs)
	return en_us2_profile_editors_birth_day(inputs)
});
export { profile_editors_birth_day as "profile-editors.birth_day" }